<template>
  <div class="payment-methods">
    <PaymentMethod
      v-for="method in paymentMethods"
      :key="method.id"
      :paymentMethod="method"
      :defaultMethod="isDefault(method)"
      @selected="onSelected"
    />
  </div>
</template>

<script>
import PaymentMethod from '@/components/donations/PaymentMethod'
export default {
  name: 'PaymentMethods',
  components: {
    PaymentMethod,
  },
  props: {
    paymentMethods: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    /* Return true if this payment method is the default payment method for this user. */
    isDefault(method) {
      return method === this.paymentMethods[0]
    },
    onSelected(method) {
      this.$emit('selected', method)
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';

.payment-methods {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 5rem;
  overflow: scroll;
}
</style>
